import useAppStore from "@/context/store";
import { useMemoizedFn, useMount, useUnmount } from "ahooks";
import { flatten } from "lodash";
import { useEffect, useRef } from "react";

// 所有pinList的pinQueue, 有两层数组，第一层表示层级，第二层表示当前层级的实例个数 示例层数：[[[],[]]]
let allPinList = [[]];

// 记录pinQueue，用于采集详情页弹窗时左右切换下一个采集功能
// 使用allPinList是解决一个页面多实例pinLis的情况
// 同时还要处理一个页面多弹窗模式下，需要覆盖的场景
export function usePinQueue(
  dataSource: any[],
  extraPinQueue: any[],
  filter: (item: any, index?: number) => boolean,
  /**是否是弹窗覆盖 */
  cover: boolean,
  disableQueue: boolean
) {
  const levelIndexRef = useRef(0);
  // 索引，用于记录当前实例pinQueue的索引位置
  const instanceIndexRef = useRef(0);

  const updatePinQueue = useMemoizedFn((data: any[]) => {
    useAppStore.setState({
      pinQueue: data.filter(filter),
    });
  });

  useMount(() => {
    // 初始化index
    levelIndexRef.current = cover
      ? allPinList.length
      : (allPinList.length || 1) - 1;
    instanceIndexRef.current = allPinList[levelIndexRef.current]?.length || 0;
  });

  useEffect(() => {
    if (disableQueue) {
      return;
    }

    const levelIndex = levelIndexRef.current;
    const currentInstanceIndex = instanceIndexRef.current;

    let currentLevelData = allPinList[levelIndex] || [];

    currentLevelData[currentInstanceIndex] = [
      ...(extraPinQueue || []),
      ...(dataSource || []),
    ];

    allPinList[levelIndex] = currentLevelData;

    // 只有当前层级是最顶层时，才将当前当前数据设置到pinQueue中
    if (levelIndex === allPinList.length - 1) {
      // 将当前层级数据设置到pinQueue中
      updatePinQueue(flatten(currentLevelData || []));
    }
  }, [dataSource, disableQueue, extraPinQueue, updatePinQueue]);

  // 销毁时，需要将当前实例数据销毁，同时复原上一层级的数据
  useUnmount(() => {
    if (disableQueue) {
      return;
    }

    const levelIndex = levelIndexRef.current;
    const currentInstanceIndex = instanceIndexRef.current;
    let currentLevelData = allPinList[levelIndex] || [];

    // 如果当前层级只有一个实例
    if (currentLevelData.length === 1) {
      // 删除当前层级
      allPinList.splice(levelIndex, 1);
      // 恢复上一层级的数据
      updatePinQueue(flatten(allPinList[levelIndex - 1] || []));
    } else {
      // 如果当前层级有多个实例，删除当前实例
      allPinList[levelIndex].splice(currentInstanceIndex, 1);

      updatePinQueue(flatten(allPinList[levelIndex]));
    }
  });
}
